import { Box, Flex, Radio, RadioGroup } from "@chakra-ui/react";
import { Control, useController } from "react-hook-form";
import { useColorTransparency } from "utils/chakraHelpers";
import { Inputs } from "./pricingCalculatorUtils";

type Props = {
  control: Control<Inputs>;
  isLoading?: boolean;
};

export default function DistributorPricingRadios({
  control,
  isLoading,
}: Props) {
  const { field } = useController({ control, name: "isDistributorMarkup" });
  const { value: isDistributorMarkup, onChange, ...controllerProps } = field;
  const priceType = isDistributorMarkup ? "Markup" : "Margin";
  const inactiveColor = useColorTransparency("magenta.veryDark", 0.5);
  return (
    <RadioGroup
      {...controllerProps}
      value={priceType}
      onChange={(v) => onChange(v === "Markup")}
      alignSelf="center"
      fontFamily="heading"
      color="magenta.veryDark"
      mr="auto"
    >
      <Flex flexWrap="wrap" mx={-1}>
        {["Margin", "Markup"].map((type) => (
          <Radio
            key={type}
            value={type}
            size="sm"
            colorScheme="lightPinkButton"
            borderColor="gray.300"
            disabled={isLoading}
            mx={1}
            id={`DistributorPricingRadios-${type}`}
          >
            <Box
              as="span"
              color={type === priceType ? undefined : inactiveColor}
              fontSize="lg"
            >
              {type}
            </Box>
          </Radio>
        ))}
      </Flex>
    </RadioGroup>
  );
}
